// extracted by mini-css-extract-plugin
export default {"main":"WelcomePage-module__main--Gt2a3","ctaContainer":"WelcomePage-module__ctaContainer--MRvYy"};